import Validator from "../validator";
import setValidationErrors from '../helpers/setValidationErrors';
import loadRecaptcha from "../helpers/loadRecaptcha";
import axios from "axios";

export default () => ({
        loading: false,
        email: '',
        password: '',
        recaptcha: null,
        authed: false,
        passwordVisible: false,
        async init() {
            this.recaptcha = await loadRecaptcha();
        },

        validate(data) {
            const rules = {
                email: 'required|email',
                password: 'required|min:6|max:50'
            }

            const validation = new Validator(data, rules, {
                'min': 'Минимально допустимое кол-во символов - :min.',
                'max': 'Маскимально допустимое кол-во символов - :max.',
                'required': 'Поле обязательно для заполнения.',
            });

            if (validation.fails()) {
                const errorMessages = Object.keys(rules)
                    .map(key => {
                        const e = validation.errors.first(key);
                        return e ? {[key]: validation.errors.first(key)} : false;
                    })
                    .filter(e => e);

                const err = Object.assign({}, ...errorMessages);

                setValidationErrors(err);

                return false;
            }

            setValidationErrors(null);

            return true;
        },

        async attempt() {
            const data = {
                email: this.email,
                password: this.password
            };

            if (this.validate(data) === false) {
                return false;
            }

            this.loading = true;

            data['recaptcha-token'] = await this.recaptcha.execute('login');


            axios.post('/login', data)
                .then(response => {
                        this.authed = true;
                        window.location.href = '/profile';
                })
                .catch(error => {
                    const {messages} = error.response.data;
                    setValidationErrors(messages);
                })
                .finally(() => this.loading = false);

            return false;
        }
    }
);
